import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[stineNumberField]',
  standalone: true,
})
export class NumberFieldDirective {
  constructor(
    private el: ElementRef,
    private control: NgControl,
  ) {}

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;
    const newValue = this.formateNumber(initialValue);
    this.control.control.setValue(newValue, { emitEvent: false });
  }

  private formateNumber(value: string): string {
    if (!value) return value;

    const number = value.replace(/\D/g, '');
    return number;
  }
}
